export class RegelSetActie {
  regelSetActieId: number;
  regelSetId: number;
  actieType: string;
  preText: string;
  waardeActie: string;
}
